export default "__VITE_ASSET__DzXDBx9u__"